import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppContextProvider } from "./AppContext";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { queryClient, localStoragePersister } from "./services/queryClient";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { initOmnisendSnippet } from "./omnisend";
// import { initGTM } from "./gtm";

// initGTM();
initOmnisendSnippet();
const NON_PERSISTED_QUERIES = ["reviews", "reviewableOrders", "orderReview"];

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <PersistQueryClientProvider
    client={queryClient}
    persistOptions={{
      persister: localStoragePersister,
      maxAge: 24 * 60 * 60 * 1000,
      throttleTime: 1000,
      dehydrateOptions: {
        shouldDehydrate: (query) =>
          query.state.status === "success" &&
          !NON_PERSISTED_QUERIES.includes(query.queryKey?.[0]),
      },
    }}
  >
    <HelmetProvider>
      <AppContextProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppContextProvider>
    </HelmetProvider>
    {/* Optional: Shows cache status in dev */}
    <ReactQueryDevtools initialIsOpen={false} />
  </PersistQueryClientProvider>,

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
